import { useAuthContext } from "src/auth/AuthContext";
import { projectService } from "src/service/ProjectService";
import ProjectsForm from "./ProjectsForm";
import { useI18n } from '@/i18n/I18nContext';

const ProjectsAdd = () => {
    const { user } = useAuthContext();
    const { t } = useI18n();

    return <ProjectsForm projectId={-1} organizationId={user.data.organizationId} onSubmit={(ps) => projectService.add(ps)} header={t('projects.form.create')}/>

}

export default ProjectsAdd
